import type { ReactElement, ReactNode } from "react";

interface HighlightEmailProps {
  children: string;
  transform: (email: string, key: string) => ReactNode;
}

export function HighlightEmail({ children, transform }: HighlightEmailProps): ReactElement {
  const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
  const parts = children.split(emailRegex);
  const matches = children.match(emailRegex) || [];

  return (
    <>
      {parts.map((part, index) => {
        if (index % 2 === 0) {
          return part;
        }
        return transform(matches[(index - 1) / 2], `email-${index}`);
      })}
    </>
  );
}
